import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const Panel = styled(Box)({
  padding: "20px 16px 24px",
  borderRadius: 20,
  marginBottom: 16,
  textAlign: "center",
  border: "1.5px solid color-mix(in oklab, var(--hot) 40%, transparent)",
  background: "linear-gradient(165deg, color-mix(in oklab, var(--hot) 12%, transparent), rgba(255,255,255,0.04))",
});

type Props = {
  savedAtIso?: string;
  onContinue: () => void;
  onNewGame: () => void;
};

export function PartyPlayResumePrompt({ savedAtIso, onContinue, onNewGame }: Props) {
  const { t, i18n } = useTranslation();
  const when =
    savedAtIso &&
    (() => {
      try {
        return new Intl.DateTimeFormat(i18n.language?.startsWith("ar") ? "ar" : "en", {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(new Date(savedAtIso));
      } catch {
        return undefined;
      }
    })();

  return (
    <Panel className="party-anim-fade-scale-in">
      <Typography className="party-mono" sx={{ fontSize: 11, letterSpacing: "0.12em", color: "var(--ink-dim)", mb: 1 }}>
        {t("party.playResume.badge")}
      </Typography>
      <Typography className="party-display" sx={{ fontSize: 22, lineHeight: 1.25, mb: 1 }}>
        {t("party.playResume.title")}
      </Typography>
      {when ? (
        <Typography sx={{ fontSize: 13, color: "var(--ink-dim)", mb: 2 }}>
          {t("party.playResume.savedAt", { when })}
        </Typography>
      ) : (
        <Typography sx={{ fontSize: 13, color: "var(--ink-dim)", mb: 2 }}>
          {t("party.playResume.subtitle")}
        </Typography>
      )}
      <Stack direction="column" gap={1.25} sx={{ mt: 1 }}>
        <Button type="button" className="party-btn party-btn-hot" fullWidth onClick={onContinue}>
          {t("party.playResume.continue")}
        </Button>
        <Button type="button" className="party-btn party-btn-paper" fullWidth onClick={onNewGame}>
          {t("party.playResume.newGame")}
        </Button>
      </Stack>
    </Panel>
  );
}
